import styled, { css } from "styled-components";
import Spring from "../../components/Spring";

export const StyledLoader = styled.div`
    margin-top: 100px;
    ${p =>
        p.theme.sm.min(css`
            margin-top: calc((100vh - 150px) / 2);
        `)}
`;

export const StyledHomeworkResult = styled(Spring)`
    background-color: ${p => p.theme.c.snow};
    padding: 20px;
    position: relative;
    p {
        text-align: justify;
    }
    min-height: calc(100vh - 50px);
`;

export const ResultsWrapper = styled.div`
    margin: 0 -20px;
`;

export const Instructions = styled.div`
    padding: 20px;
    ${p => p.theme.sm.max(css`
        padding: 20px 0;
    `)}
    margin: auto;
    max-width: 380px;
    line-height: 28px;
    p {
        margin-top: 8px;
        margin-bottom: 0;
    }
    ol {
        padding-left: 6px;
        margin-top: 4px;
    }
    li {
        text-align: left;
        list-style: none;
        counter-increment: li;
        text-indent: -22px;
        margin-left: 22px;
        * {
            text-indent: 0;
        }
    }

    li:before {
        content: counter(li) ".";
        margin-right: 10px;
    }

    h4 {
        text-align: center;
        margin-top: 0;
        margin-bottom: 32px;
    }

    .Method {
        margin: -16px 0 -4px 28px;
        line-height: 20px;
        text-transform: uppercase;
    }

    .HiddenListStyle:before {
        visibility: hidden;
    }

    .ListStyleLowered:before {
        top: 24px;
        position: relative;
    }

    a {
        text-indent: 0;
    }
`;

export const CardContainer = styled.div`
    margin: auto;
    padding: 20px;
    ${p => p.theme.sm.max(css`
        padding: 20px 0;
    `)}
    padding-bottom: 0;
    max-width: 380px;
    margin-bottom: 20px;
    margin-top: 20px;
`;

export const PageWrapper = styled.div``;
